export default __webpack_public_path__ + "static/media/cashback.ee452fd3.png";